export enum IntervalType {
  INTERVAL_WEEK = "INTERVAL_WEEK",
  INTERVAL_MONTH = "INTERVAL_MONTH",
}
